var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#9A3277",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1769 32.7245H20.0981M18.1072 20.1462L19.5701 13.0011M26.3632 17.9337L27.8261 10.7885M11.1769 22.0045H37.3438V36.2491C37.3438 36.8553 37.103 37.4367 36.6743 37.8653C36.2456 38.294 35.6643 38.5348 35.0581 38.5348H13.4603C12.8541 38.5348 12.2727 38.294 11.8441 37.8653C11.4154 37.4367 11.1746 36.8553 11.1746 36.2491L11.1769 22.0045ZM11.1746 22.0045L36.4455 15.2319L35.3483 11.1405C35.2709 10.8503 35.137 10.5783 34.9543 10.3399C34.7716 10.1014 34.5438 9.90138 34.2837 9.75109C34.0237 9.60079 33.7366 9.50323 33.4388 9.46396C33.141 9.42469 32.8384 9.44449 32.5483 9.52223L11.6935 15.1131C11.1084 15.2701 10.6095 15.6529 10.3065 16.1775C10.0034 16.7021 9.92109 17.3255 10.0775 17.9108L11.1746 22.0045Z",
    stroke: "#9A3277",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.aba14f177ef4960a75fe1150cd77f056.svg";
export { ForwardRef as ReactComponent };